var scrollTo;

$(function() {
    scrollTo = function(selector) {
        var target = $(selector);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
            $('html, body').animate({
                scrollTop: target.offset().top
            }, 1000);
            
            return false;
        }
    }
    
    $('a[href*="#"]:not([href="#"])').on('click', function(e) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
            $('html, body').animate({
                scrollTop: target.offset().top
            }, 1000);
            
            return false;
        }
    });
});